/**
 * Premium micro-interactions.
 *
 * Currently powers the opt-in scroll-reveal utility: any element with a
 * `data-reveal` attribute fades and rises into view the first time it
 * enters the viewport. Elements are inert (fully visible, no observer
 * cost) unless they carry the attribute, so this is safe to load
 * sitewide and has zero effect until sections opt in.
 *
 * Respects prefers-reduced-motion (handled in CSS) and degrades to
 * "always visible" if IntersectionObserver isn't available.
 */
(function () {
  var SELECTOR = '[data-reveal]';

  function revealAll(elements) {
    elements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init() {
    var elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan after Shopify section re-renders (theme editor, section hydration).
  document.addEventListener('shopify:section:load', init);
})();
